import {
    Grid,
    Box,
    useTheme,
    useMediaQuery,
    IconButton,
    InputAdornment,
} from '@mui/material';

import TypographyLevel from 'shared/components/Typography';
import {
    AppFormikTextField,
    ButtonComp,
} from 'shared/components/AppComponents';
import { ReactElement, useLayoutEffect, useState } from 'react';
import { FormikSearchPropsValues } from 'modules/authentication/components/ManageClientsPage';
import { useFormikContext } from 'formik';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { useDebounce } from 'react-use';

/**
 * Component for the main header in the Manage Clients page.
 * @param {MCHeaderMainProps} props - The component props.
 * @returns {ReactElement} React element representing the main header component.
 */
const MCHeaderMain: React.FC<MCHeaderMain> = (props): ReactElement => {
    const { setStatusPage } = props;
    const theme = useTheme();
    const match = useMediaQuery(theme.breakpoints.up('md'));
    const { handleSubmit, getFieldMeta, handleReset } =
        useFormikContext<FormikSearchPropsValues>();

    const searchField = getFieldMeta('search');
    const [val, setVal] = useState<string>('');
    const [debouncedValue, setDebouncedValue] = useState<string>('');

    const [, cancel] = useDebounce(
        () => {
            setDebouncedValue(val);
        },
        2000,
        [val]
    );
    useLayoutEffect(() => {
        handleSubmit();
    }, [debouncedValue]);

    return (
        <Grid className="header-list-client" container columnSpacing={0}>
            {match ? (
                <>
                    <Grid
                        xs={12}
                        md={2}
                        sm={12}
                        lg={1}
                        item
                        className="header-client-item"
                    >
                        <Box>
                            <TypographyLevel variant="two" component="h3">
                                Checklists
                            </TypographyLevel>
                        </Box>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={7}
                        lg={9}
                        className="header-client-item"
                    >
                        <Box className="manage-client-relative">
                            <AppFormikTextField
                                name="search"
                                className={
                                    searchField.touched
                                        ? 'inputSearchBox touched'
                                        : 'inputSearchBox'
                                }
                                id="input-searchbox"
                                placeholder="Type checklists name to search"
                                onChange={(ev: any) => setVal(ev.target.value)}
                                inputProps={{
                                    endAdornment: (
                                        <>
                                            <InputAdornment position="start">
                                                <IconButton
                                                    onClick={(e: any) => {
                                                        handleReset(e);
                                                        cancel();
                                                    }}
                                                    edge="end"
                                                    className="text-primary"
                                                    title="Remove searched checklist"
                                                >
                                                    <CloseIcon />
                                                </IconButton>
                                            </InputAdornment>
                                            <InputAdornment position="end">
                                                <IconButton
                                                    // onClick={() => {
                                                    //     handleSubmit();
                                                    // }}
                                                    title="search checklist"
                                                    edge="end"
                                                    className="text-primary"
                                                >
                                                    <SearchIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        </>
                                    ),
                                }}
                            />
                            {/* <Box>
                                <IconButton onClick={removeInputRef}>
                                    <img
                                        src="/images/icons/CloseX.svg"
                                        height={15}
                                        width={15}
                                    />
                                </IconButton>
                                <Box>
                                    <IconButton>
                                        <img
                                            src="/images/icons/Search.svg"
                                            height={20}
                                            width={20}
                                        />
                                    </IconButton>
                                </Box>
                            </Box> */}
                        </Box>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={3}
                        lg={2}
                        className="header-client-item"
                    >
                        <Box>
                            <ButtonComp
                                onClick={() => {
                                    setStatusPage('add');
                                }}
                                type="primary"
                            >
                                Add new checklists
                            </ButtonComp>
                        </Box>
                    </Grid>
                </>
            ) : (
                <>
                    <Grid
                        xs={12}
                        sm={6}
                        md={2}
                        lg={1}
                        item
                        className="header-client-item"
                    >
                        <Box>
                            <TypographyLevel variant="two" component="h3">
                                Checklists
                            </TypographyLevel>
                        </Box>
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={3}
                        lg={2}
                        className="header-client-item"
                    >
                        <Box>
                            <ButtonComp
                                onClick={() => {
                                    setStatusPage('add');
                                }}
                                type="primary"
                            >
                                Add new checklists
                            </ButtonComp>
                        </Box>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={7}
                        lg={9}
                        className="header-client-item"
                    >
                        <Box>
                            <AppFormikTextField
                                name="search"
                                className={
                                    searchField.touched
                                        ? 'inputSearchBox touched'
                                        : 'inputSearchBox'
                                }
                                id="input-searchbox"
                                placeholder="Type checklist name to search"
                                onChange={(ev: any) => setVal(ev.target.value)}
                                inputProps={{
                                    endAdornment: (
                                        <>
                                            <InputAdornment position="start">
                                                <IconButton
                                                    title="Remove searched checklist"
                                                    onClick={(e: any) => {
                                                        handleReset(e);
                                                        cancel();
                                                    }}
                                                    edge="end"
                                                    className="text-primary"
                                                >
                                                    <CloseIcon />
                                                </IconButton>
                                            </InputAdornment>
                                            <InputAdornment position="end">
                                                <IconButton
                                                    title="search checklist"
                                                    // onClick={() => {
                                                    //     handleSubmit();
                                                    // }}
                                                    edge="end"
                                                    className="text-primary"
                                                >
                                                    <SearchIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        </>
                                    ),
                                }}
                            />

                            {/* <Box>
                                <ButtonComp
                                    src="/images/icons/Search.svg"
                                    height={20}
                                    width={20}
                                    onClick={handleSubmit}
                                />
                            </Box> */}
                        </Box>
                    </Grid>
                </>
            )}
        </Grid>
    );
};

export default MCHeaderMain;
